import { LazyLoadImage } from "react-lazy-load-image-component";
import { HiMiniXMark } from "react-icons/hi2";
import { IoMdCheckmark } from "react-icons/io";
import DropdownMenubar from "../components/Menubar/DropdownMenubar";

// Dropdown for vendor actions
const DropdownActions = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

// Vendor information with approve/unapprove actions
const getVendorInfo = (row, handleCellClick) => {
  return DropdownActions([
    {
      label: "APPROVE",
      icon: (
        <div className="text-white rounded-full bg-green600">
          <IoMdCheckmark className="" />
        </div>
      ),
      command: () => {
        handleCellClick(row, "Approved");
      },
    },
    {
      label: "UNAPPROVE",
      icon: (
        <div className="text-white rounded-full bg-red600">
          <HiMiniXMark className="" />
        </div>
      ),
      command: () => {
        handleCellClick(row, "Rejected");
      },
    },
  ]);
};

const getOrderReferenceText = (orderReference) => {
  if (!orderReference) return "";
  if (typeof orderReference === "string") return orderReference;

  // populated object case
  return orderReference.order_id || orderReference._id || "";
};

// Column definitions
export const columns = [
  {
    field: "issueNumber",
    header: "Issued Number",
    accessor: (row, handleCellClick) => (
      <div
        className="text-GreenColor font-semibold cursor-pointer hover:underline"
        onClick={() => handleCellClick(row, "issueNumber")}
        title="Click to view details"
      >
        {row.issueNumber || <span className="text-[#6B7280]">N/A</span>}
      </div>
    ),
  },
  {
    field: "dateOfIssue",
    header: "Date of Issue",
    accessor: (row) => (
      <div className="text-sm text-[#4A5568] font-medium">
        {row.dateOfIssue ? (
          <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue800 text-xs font-semibold rounded-full">
            {new Date(row.dateOfIssue).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        ) : (
          <span className="text-[#6B7280]">N/A</span>
        )}
      </div>
    ),
  },
  {
    field: "issuedTo",
    header: "Issued To",
    accessor: (row) => (
      <div className="text-sm font-medium text-gray-700 truncate max-w-[150px]">
        {row.issuedTo || <span className="text-[#6B7280]">N/A</span>}
      </div>
    ),
  },
  {
    field: "vendorLocation",
    header: "Vendor Location",
    accessor: (row) => (
      <div className="text-sm text-gray-700 truncate max-w-[150px]">
        <i className="fas fa-map-marker-alt text-RedColor mr-1"></i>
        {row.vendorLocation || <span className="text-[#6B7280]">N/A</span>}
      </div>
    ),
  },
  {
    field: "orderReference",
    header: "Order Reference",
    accessor: (row) => {
      const refText = getOrderReferenceText(row.orderReference);

      return (
        <div className="text-sm font-medium text-gray-700 truncate max-w-[150px]">
          {refText ? refText : <span className="text-[#6B7280]">N/A</span>}
        </div>
      );
    },
  },
  {
    field: "receivedBy",
    header: "Received By",
    accessor: (row) => (
      <div className="text-sm font-medium text-gray-700 truncate max-w-[150px]">
        {row.receivedBy || <span className="text-[#6B7280]">N/A</span>}
      </div>
    ),
  },
  {
    field: "attachments",
    header: "Attachments",
    accessor: (row) => (
      <div className="w-20 h-20 overflow-hidden rounded-md border border-lightGrayColor shadow-sm">
        {row.attachments ? (
          <img
            src={row.attachments}
            alt="Attachment"
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-[#6B7280] text-sm flex items-center justify-center h-full">
            No Image
          </span>
        )}
      </div>
    ),
  },
  {
    field: "itemDetails",
    header: "Item Details",
    accessor: (row, handleCellClick) => (
      <div
        className="space-y-4 text-green700"
        onClick={() => handleCellClick(row, "viewDetails")}
      >
        View
      </div>
    ),
  },
  {
    field: "createdAt",
    header: "Created At",
    accessor: (row) => (
      <div className="text-sm text-[#4A5568] font-medium">
        {row.createdAt ? (
          <span className="inline-flex items-center px-3 py-1 bg-green-100 text-green800 text-xs font-semibold rounded-full">
            {new Date(row.createdAt).toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        ) : (
          <span className="text-[#6B7280]">N/A</span>
        )}
      </div>
    ),
  },
];

// Search filters configuration
export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

// Approval status filters
export const filters = [
  {
    filterType: "Filter by Status",
    inputName: "status",
    options: [
      {
        name: "Approved",
        code: "Approved",
      },
      {
        name: "Rejected",
        code: "Rejected",
      },
    ],
  },
];
